module.exports = __webpack_public_path__ + "static/media/svgclosepiano.965a3d0e.svg";